export default (cost) => cost.toFixed(2);
